/**
 * @desc 待进口信息提交
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(body: defs.tms.TransportDjkRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/djkTransportMaster`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
